var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show === true)?_c('div',{staticClass:"carregando"},[_c('img',{staticStyle:{"max-width":"90%"},attrs:{"src":_vm.BP_LOGO}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }